


export class ZVSD1 {
  "sdDocumentCategory";
  "salesDocument";
  "salesOrganization";
  "salesDocumentNetValue";
  "customerPurchaseOrderNumber";
  "wbsElement";
  "customerName";
  "nameOfPersonWhoCreatedTheSalesDocument";
  "completionNoteTextPt";
  "termsOfPayment";
  "salesSequence";
  "materialCode";
  "pCodeInSalesDocument";
  "grossValue";
  "netValue";
  "termsOfPaymmentKey";
  "shipToPoDataPoNumberSolutionDescription";
  "loadDate";
  "referenceNoNf";
  "billingItem";
  "referenceDoc";
  "itemNoteTextPt";
  "wbsElement2";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ZVSD1`.
   */
  static getModelName() {
    return "ZVSD1";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ZVSD1 for dynamic purposes.
  **/
  static factory(data) {
    return new ZVSD1(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ZVSD1',
      plural: 'ZVSD1s',
      path: 'ZVSD1s',
      properties: {
        "sdDocumentCategory": {
          name: 'sdDocumentCategory',
          type: 'string'
        },
        "salesDocument": {
          name: 'salesDocument',
          type: 'string'
        },
        "salesOrganization": {
          name: 'salesOrganization',
          type: 'string'
        },
        "salesDocumentNetValue": {
          name: 'salesDocumentNetValue',
          type: 'string'
        },
        "customerPurchaseOrderNumber": {
          name: 'customerPurchaseOrderNumber',
          type: 'string'
        },
        "wbsElement": {
          name: 'wbsElement',
          type: 'string'
        },
        "customerName": {
          name: 'customerName',
          type: 'string'
        },
        "nameOfPersonWhoCreatedTheSalesDocument": {
          name: 'nameOfPersonWhoCreatedTheSalesDocument',
          type: 'string'
        },
        "completionNoteTextPt": {
          name: 'completionNoteTextPt',
          type: 'string'
        },
        "termsOfPayment": {
          name: 'termsOfPayment',
          type: 'string'
        },
        "salesSequence": {
          name: 'salesSequence',
          type: 'string'
        },
        "materialCode": {
          name: 'materialCode',
          type: 'string'
        },
        "pCodeInSalesDocument": {
          name: 'pCodeInSalesDocument',
          type: 'string'
        },
        "grossValue": {
          name: 'grossValue',
          type: 'string'
        },
        "netValue": {
          name: 'netValue',
          type: 'string'
        },
        "termsOfPaymmentKey": {
          name: 'termsOfPaymmentKey',
          type: 'string'
        },
        "shipToPoDataPoNumberSolutionDescription": {
          name: 'shipToPoDataPoNumberSolutionDescription',
          type: 'string'
        },
        "loadDate": {
          name: 'loadDate',
          type: 'string'
        },
        "referenceNoNf": {
          name: 'referenceNoNf',
          type: 'string'
        },
        "billingItem": {
          name: 'billingItem',
          type: 'string'
        },
        "referenceDoc": {
          name: 'referenceDoc',
          type: 'string'
        },
        "itemNoteTextPt": {
          name: 'itemNoteTextPt',
          type: 'string'
        },
        "wbsElement2": {
          name: 'wbsElement2',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ZVSD1.js